// extracted by mini-css-extract-plugin
export var boldText = "_7u-4";
export var checkboxContainer = "_7u-6";
export var closeIcon = "_7u-i";
export var container = "_7u-0";
export var drawer = "_7u-8";
export var drawerContent = "_7u-9";
export var extraSmallText = "_7u-5";
export var fulfillmentGroupTable = "_7u-e";
export var largeText = "_7u-3";
export var loadingSpinnerContainer = "_7u-j";
export var mediumText = "_7u-2";
export var narrow = "_7u-f";
export var notificationLink = "_7u-l";
export var packageCheckIconContainer = "_7u-7";
export var slideoutHeaderActions = "_7u-g";
export var slideoutHeaderActionsShifted = "_7u-h";
export var slideoutHeaderContainer = "_7u-a";
export var slideoutModal = "_7u-c";
export var stickyHeaderWrapper = "_7u-b";
export var table = "_7u-k";
export var tableContainer = "_7u-d";
export var tertiaryText = "_7u-1";